import axios from 'axios';

export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const fetchDashboardData = (filters = { timezone: 'Asia/Kolkata', upcomingLimit: 5 }) => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_REQUEST });
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'dashboard',
      command: 'getDashboardData',
      filters,
    });

    dispatch({
      type: FETCH_DASHBOARD_SUCCESS,
      payload: response?.data?.data || {},
    });
  } catch (error) {
    dispatch({
      type: FETCH_DASHBOARD_FAILURE,
      payload: error?.response?.data?.message || error.message || 'Failed to fetch dashboard data',
    });
  }
};
